export const apis = {
  register: "/auth/registration",
  new_password: "/auth/registration/generate_new_password",
  sessions: "/auth/sessions",
  select_customer:"/auth/sessions/select_customer",
  logout: "auth/sessions/destroy",
  clear_cart: (id) => `/carts/${id}`,
  support_sessions: "/supports/get_user_details_from_support",
  forgot_password: "/auth/registration/forgot_password", // params email
  reset_password: "/auth/registration/reset_password",
  addresses: "/addresses", // params email and authentication_token
  regions: "/fd_regions", // params email and authentication_token
  origins: "/fd_origins", // params email and authentication_token
  products: "/products", // params email and authentication_token
  list_products: "/products/list_products", // params email and authentication_token
  line_items: "/line_items",
  bulk_order: "/create_bulk_order",
  orders: "/orders",
  carts: "/carts",
  update_line_items: (id) => `/line_items/${id}/update_quntity`,
  product_filters: "/products/product_filters",
  filter_prods: "/products/filter_products",
  update_order: "/orders/update_order",
  add_comments: "/orders/create_order_comment",
  get_comments: "/orders/get_order_comments",
  order_history: "/orders/order_history",
  order_repeat: "/orders/repeat_order",
  dashboard: "/dash_board",
  sales_orders: "/orders/sales_orders",
  get_proforma_doc: "/orders/get_proforma_doc",
  update_sales_order_status: "/orders/update_sales_order_status",
  customer_shipments_list: "/customer_shipments_list",
  customer_payment_terms: "/customer_payment_terms",
  customer_shipment_terms: "/customer_shipment_terms",
  customer_shipment_doc: "/customer_shipment_doc",
  customer_billing_doc: "/customer_billing_doc",
  customer_billing_list: "/customer_billing_list",
  customer_shipment_track: "/customer_shipment_track",
  customer_shipment_details: "/customer_shipment_details",
  customer_open_order_products: "/customer_open_order_products",
  customer_open_product_orders: "/customer_open_product_orders",
  sync_customer_orders: "/sync_customer_orders",
  sync_customer_details: "/sync_customer_details",
  profile: "/profile",
  fetch_claim_list: "/fetch_claim_list",
  invoice_status_update: "/delivery_invoice_status_update",
  payments: "/payments",
  alerts_list: "/alerts_list",
  credit_notes: "/fetch_credit_notes",
  create_claim: "/create_claim",
  create_delegate_user: "/customers/add_delegate_user",
  get_delegate_users: "/customers/delegate_users",
  delete_delegate_user: (id) => `/customers/delete_delegate_user/${id}`,
  update_delegate_user: (id) => `/customers/update_delegate_user/${id}`,
  upload_preshipment_file: "/upload_preshipment_file",
  upload_claim_image: "/upload_claim_image",
  fetch_claim_details: "/fetch_claim_details",
  claims_doc_list: "/claims/claims_doc_list",
  download_claim_doc: '/claims/download_claim_doc',
  download_signed_perofoma_invoice: "/download_signed_perofoma_invoice",
  cancle_order: "/orders/cancle_order",
  fetch_warranty: "/marketings/fetch_warranty",
  marketings: "/marketings",
  alerts_seen_status: "/alerts_delete",
  export_product_file: "/products/export_product_file",
  shipment_status_history: "/shipment_status_history",
  timezone_fetch: "/timezone_fetch",
  price_update_worker: "/products/price_update_worker",
  on_water_report: "/customer_onwaterreport_details",
  inventory_report: "/customer_inventory_details",
  last_login: "/auth/registration/last_login",
};
